import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, delay } from 'rxjs';
import { OrderPreemptModel, OrderPreemptSearchParams, OrderPreemptResponse, OrderPreemptActionResponse } from './order-preempt.model';

@Injectable({
  providedIn: 'root'
})
export class OrderPreemptService {
  // private http = inject(HttpClient);

  // Mock data for demonstration
  private mockOrders: OrderPreemptModel[] = [
    {
      id: '1',
      thirdPartyOrderNumber: 'a',
      internalOrderNumber: 'CO00000009',
      preemptCode: 'CO00000013',
      preemptStatus: 'All Preempt Failed',
      productTypes: 1,
      totalProductLines: 1,
      pendingPreempt: 0,
      preemptSuccess: 0,
      salesChannel: 'Shopee',
      preemptFailed: 1,
      salesStore: 'Colorful Good Goods Warehouse',
      thirdPartyOrderTime: '2025-08-01 00:00:00',
      internalOrderCreationTime: '2025-08-05 19:24:25',
      expectedShipmentTime: '2025-08-10 00:00:00'
    },
    {
      id: '2',
      thirdPartyOrderNumber: 'OD202511250001',
      internalOrderNumber: 'CO00000017',
      preemptCode: 'CO00000052',
      preemptStatus: 'All Preempt Failed',
      productTypes: 4,
      totalProductLines: 21,
      pendingPreempt: 0,
      preemptSuccess: 0,
      salesChannel: 'Shopee',
      preemptFailed: 21,
      salesStore: 'Trend Station',
      thirdPartyOrderTime: '2025-05-06 00:00:00',
      internalOrderCreationTime: '2025-05-07 09:07:55',
      expectedShipmentTime: '2025-05-12 00:00:00'
    },
    {
      id: '3',
      thirdPartyOrderNumber: 'test1112',
      internalOrderNumber: 'CO00000052',
      preemptCode: 'CO00000059',
      preemptStatus: 'All Preempt Failed',
      productTypes: 2,
      totalProductLines: 3,
      pendingPreempt: 0,
      preemptSuccess: 0,
      salesChannel: 'Shopee',
      preemptFailed: 3,
      salesStore: 'Happy Selection Online Store',
      thirdPartyOrderTime: '2025-04-01 00:00:00',
      internalOrderCreationTime: '2025-04-02 16:08:39',
      expectedShipmentTime: '2025-04-07 00:00:00'
    },
    {
      id: '4',
      thirdPartyOrderNumber: 'test111',
      internalOrderNumber: 'CO00000047',
      preemptCode: 'CO00000051',
      preemptStatus: 'All Preempt Failed',
      productTypes: 1,
      totalProductLines: 1,
      pendingPreempt: 0,
      preemptSuccess: 0,
      salesChannel: 'Shopee',
      preemptFailed: 1,
      salesStore: 'Happy Selection Online Store',
      thirdPartyOrderTime: '2025-04-01 00:00:00',
      internalOrderCreationTime: '2025-04-02 16:07:14',
      expectedShipmentTime: '2025-04-07 00:00:00'
    },
    {
      id: '5',
      thirdPartyOrderNumber: '454554',
      internalOrderNumber: 'CO00000037',
      preemptCode: 'CO00000044',
      preemptStatus: 'All Preempt Failed',
      productTypes: 2,
      totalProductLines: 2,
      pendingPreempt: 0,
      preemptSuccess: 0,
      salesChannel: 'Shopee',
      preemptFailed: 2,
      salesStore: 'Trend Station',
      thirdPartyOrderTime: '2025-03-01 00:00:00',
      internalOrderCreationTime: '2025-03-23 22:26:39',
      expectedShipmentTime: '2025-03-28 00:00:00'
    }
  ];

  getOrders(params: OrderPreemptSearchParams): Observable<OrderPreemptResponse> {
    // Simulate API delay
    return of({
      data: this.mockOrders,
      total: this.mockOrders.length,
      success: true,
      message: 'Orders retrieved successfully'
    });
  }

  retryPreempt(orderIds: string[]): Observable<OrderPreemptActionResponse> {
    // Simulate API call for retrying preempt
    return of({
      success: true,
      message: `Preempt retry initiated for ${orderIds.length} orders`,
      affectedCount: orderIds.length
    }).pipe(delay(1000));
  }

  exportOrders(params: OrderPreemptSearchParams): Observable<string> {
    // Simulate CSV export
    const headers = [
      'Third Party Order Number',
      'Internal Order Number', 
      'Preempt Code',
      'Preempt Status',
      'Product Types',
      'Total Product Lines',
      'Pending Preempt',
      'Preempt Success',
      'Sales Channel',
      'Preempt Failed',
      'Sales Store',
      'Third Party Order Time',
      'Internal Order Creation Time',
      'Expected Shipment Time'
    ];

    const rows = this.mockOrders.map(order => [
      order.thirdPartyOrderNumber,
      order.internalOrderNumber,
      order.preemptCode,
      order.preemptStatus,
      order.productTypes.toString(),
      order.totalProductLines.toString(),
      order.pendingPreempt.toString(),
      order.preemptSuccess.toString(),
      order.salesChannel,
      order.preemptFailed.toString(),
      order.salesStore,
      order.thirdPartyOrderTime,
      order.internalOrderCreationTime,
      order.expectedShipmentTime
    ]);

    const csvContent = [headers, ...rows]
      .map(row => row.map(cell => `"${cell}"`).join(','))
      .join('\n');

    return of(csvContent).pipe(delay(500));
  }
} 